import {OnMounted} from "@Common/react/on-mounted";
import {chain}     from "@Common/utils/fs";

import {floorSize}       from "../../common/floor-size";
import {getContainRatio} from "../../common/get-contain-ratio";
import {multiplySize}    from "../../common/multiply-size";
import {multiplyVector}  from "../../common/multiply-vector";
import {pointsToRect}    from "../../common/points-to-rect";
import {roundSize}       from "../../common/round-size";
import {roundVector}     from "../../common/round-vector";

export const AutoRect = ({frame, desktop, aspectRatio, onDone}) => OnMounted({
    action: () => {
        const r1 = {x:0,y:0, ...multiplySize(frame.size, 1/frame.ratio)};
        const r2 = chain(
            multiplySize(desktop.getBoundingClientRect(), 1/frame.ratio),
            floorSize,
            (_) => ({
                ...chain(
                    multiplyVector(frame.start, -1/frame.ratio),
                    roundVector,
                ),
                ..._,
            }),
        );

        onDone(chain(
            innerRect(r1, r2),
            // addPadding,
            (_) => !aspectRatio ? (
                _
            ) : (
                containRect(_, aspectRatio)
            ),
        ));
        // console.log(innerRect(r1, r2));
    },
});

const containRect = (rect, size) => {
    const ratio = getContainRatio(rect, size);
    return chain(
        {
            x: rect.x + (rect.width  - size.width  * ratio) / 2,
            y: rect.y + (rect.height - size.height * ratio) / 2,
            width : size.width  * ratio,
            height: size.height * ratio,
        },
        roundRect,
    );
};

const roundRect = (r) => ({
    ...roundVector(r),
    ...roundSize(r),
})

const innerRect = (r1, r2) => pointsToRect(
    {
        x: Math.max(r1.x, r2.x),
        y: Math.max(r1.y, r2.y),
    },
    {
        x: Math.min(r1.x + r1.width , r2.x + r2.width ),
        y: Math.min(r1.y + r1.height, r2.y + r2.height),
    },
);
